import styled from 'styled-components';
import { Link as StyledLink } from './styles';

const Link = ({ children, prefetch = false, ...props }) => {
  return (
    <StyledLink prefetch={prefetch} {...props}>
      {children}
    </StyledLink>
  );
};

const LinkLegal = styled(Link)`
  color: #afafaf;
  text-decoration-line: underline;
`;

export { Link, LinkLegal };
